// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./MobileFormControls.css";
import { getThemePreference, applyThemePreference } from "./theme";

const pref = getThemePreference();
applyThemePreference(pref);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL || ""}/service-worker.js`)
            .catch((err) => {
                console.error("Service worker registration failed:", err);
            });
    });
}
